import { cn as cnBase } from "../../../lib/utils";

// Helper function for occupancy color
export const getOccupancyColor = percentage => {
  if (percentage >= 90) return "text-green-600 font-semibold";
  if (percentage >= 70) return "text-teal-600";
  if (percentage >= 50) return "text-yellow-600";
  return "text-red-600";
};

export const cn = cnBase;
